import React from "react";
import { Row, Col, Badge } from "react-bootstrap";
import { CommonModal, CommonButton } from "../Input";
import DetailField from "../Customers/CustomerDetails/DetailField";
import DownloadService from "../../../services/DownloadService";

const SectionContainer = ({ title, children, extra }) => (
  <div className="mb-4">
    <div className="d-flex justify-content-between align-items-center mb-2">
      <h6 className="fw-bold mb-0 fs-14 text-black">{title}</h6>
      {extra}
    </div>
    <div className="rounded-2 p-4 bg-body">
      <Row className="gy-3">{children}</Row>
    </div>
  </div>
);

const TransactionInformationModal = ({ show, onHide, transaction }) => {
  if (!transaction) return null;

  const CustomHeader = () => (
    <div className="w-100 d-flex justify-content-between align-items-center py-1 pe-4">
      <div>
        <h4 className="fw-bold text-black mb-1">Transaction details</h4>
        <p className="fs-13 text-muted mb-0 fw-normal">
          View full transaction details and download receipts
        </p>
      </div>
      <div className="d-flex align-items-center gap-2">
        <CommonButton
          variant="outline"
          className="py-1 px-3 d-flex align-items-center bg-white border"
          style={{
            fontSize: "12px",
            height: "36px",
            color: "#333",
            fontWeight: "600",
            borderRadius: "8px",
          }}
        >
          <i className="fas fa-print me-2 fs-14 text-muted"></i> Print receipt
        </CommonButton>
        <CommonButton
          variant="outline"
          className="py-1 px-3 d-flex align-items-center bg-white border"
          style={{
            fontSize: "12px",
            height: "36px",
            color: "#333",
            fontWeight: "600",
            borderRadius: "8px",
          }}
        >
          <i className="far fa-envelope me-2 fs-14 text-muted"></i> Email
        </CommonButton>
        <CommonButton
          variant="outline"
          className="py-1 px-3 d-flex align-items-center bg-white border"
          style={{
            fontSize: "12px",
            height: "36px",
            color: "#333",
            fontWeight: "600",
            borderRadius: "8px",
          }}
        >
          <i className="fas fa-download me-2 fs-14 text-muted"></i> Download
        </CommonButton>
      </div>
    </div>
  );

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      customHeader={<CustomHeader />}
      size="xl"
      className="modal-premium"
      modalProps={{ centered: true }}
      footer={null}
    >
      <div className="px-1 py-1">
        {/* Sender Section */}
        <SectionContainer title="Sender">
          <Col md={2} sm={4}>
            <DetailField label="Customer type" value="Individual" />
          </Col>
          <Col md={3} sm={8}>
            <DetailField label="Sender name" value="test manual transaction" />
          </Col>
          <Col md={2} sm={4}>
            <DetailField label="Customer ID" value="129" />
          </Col>
          <Col md={2} sm={4}>
            <DetailField label="ID type" value="NRIC - Citizen" />
          </Col>
          <Col md={3} sm={4}>
            <DetailField label="ID number" value="123123123123" />
          </Col>
        </SectionContainer>

        {/* Beneficiaries Content */}
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h6 className="fw-bold mb-0 fs-14 text-black">Beneficiaries</h6>
            <Badge
              bg="transparent"
              className="px-3 py-1 border rounded fs-10"
              style={{
                color: "#6B72F7",
                backgroundColor: "#F4F3FF",
                borderColor: "#C6C9FF",
                fontWeight: "600",
                letterSpacing: "0.3px",
              }}
            >
              Waiting for AML beneficiary approval
            </Badge>
          </div>

          <div className="rounded-2 p-4 bg-body">
            <Row>
              <Col lg={8} className="border-end border-light pe-lg-4">
                <Row className="gy-3">
                  <Col md={4} sm={6}>
                    <DetailField label="Transaction ID" value="259" />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField label="Created date" value="10/03/2026 17:59:56" />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField label="Receiver name" value="IDR indonesia" />
                  </Col>

                  <Col md={4} sm={6}>
                    <DetailField label="Receiver type" value="Organization" />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField label="Receiving method" value="Bank transfer" />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField label="Bank / Agent" value="BCA Digital" />
                  </Col>

                  <Col md={4} sm={6}>
                    <DetailField label="Country" value="Indonesia" />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField label="Acc no./IBAN" value="05520000003601" />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField label="Address" value="-" />
                  </Col>

                  <Col md={4} sm={6}>
                    <DetailField label="IFSC code" value="-" />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField
                      label="Purpose of transfer"
                      value="Supplier/vendor/agent payment"
                    />
                  </Col>
                  <Col md={4} sm={6}>
                    <DetailField label="Source of funds" value="Savings" />
                  </Col>
                </Row>
              </Col>
              <Col lg={4} className="ps-lg-4 mt-4 mt-lg-0">
                <div className="bg-white rounded-3 p-3 border border-light">
                  <h6
                    className="fw-bold text-muted text-uppercase mb-3"
                    style={{ fontSize: "11px", letterSpacing: "0.5px" }}
                  >
                    Amount Details
                  </h6>
                  {[
                    { label: "Receiving amount", value: "129,131.959 IDR" },
                    { label: "Exchange rate", value: "1 SGD = 11,739.269 IDR" },
                    { label: "Send amount", value: "11.00 SGD" },
                    { label: "Service charge", value: "0.00 SGD" },
                    { label: "Promo Code", value: "0.00 SGD" },
                  ].map((item, idx) => (
                    <div
                      key={idx}
                      className="d-flex justify-content-between mb-2 pb-2 border-bottom border-light border-opacity-50"
                    >
                      <span className="text-muted fs-12">{item.label}</span>
                      <span className="fw-bold text-black fs-12">
                        {item.value}
                      </span>
                    </div>
                  ))}
                  <div className="d-flex justify-content-between mt-3 pt-2">
                    <span className="text-black fw-bold fs-13">Total amount</span>
                    <span className="fw-bold text-primary fs-15">11.00 SGD</span>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {/* Invoices Section */}
        <div className="mb-4">
          <h6 className="fw-bold mb-3 fs-14 text-black">Invoices</h6>
          <Row className="gy-3">
            <Col md={3}>
              <div
                className="bg-white rounded-3 p-4 text-center border border-light shadow-sm d-flex flex-column align-items-center justify-content-center"
                style={{ height: "200px" }}
              >
                <div className="mb-3">
                  <i className="fas fa-file-pdf text-danger fs-32 opacity-75"></i>
                </div>
                <div className="fw-bold text-black fs-12 mb-1 text-truncate w-100 px-2">
                  5671c5c4-588d.pdf
                </div>
                <div className="text-muted fs-10 mb-3 text-uppercase fw-bold opacity-50">
                  PDF Documents
                </div>
                <CommonButton
                  variant="outline"
                  className="btn-sm border border-light w-100 bg-light-gray fs-11 fw-bold"
                  style={{ height: "32px", borderRadius: "8px" }}
                  onClick={() =>
                    DownloadService.downloadFile(
                      "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
                      "invoice_5671c5c4.pdf",
                    )
                  }
                >
                  <i className="fas fa-download me-2"></i> Download
                </CommonButton>
              </div>
            </Col>
            {[
              {
                url: "https://images.unsplash.com/photo-1549488344-1f9b8d2bd1f3?q=80&w=2670&auto=format&fit=crop",
                name: "invoice_image_1.jpg",
              },
              {
                url: "https://images.unsplash.com/photo-1554224155-1696413565d3?q=80&w=2670&auto=format&fit=crop",
                name: "invoice_image_2.jpg",
              },
              {
                url: "https://images.unsplash.com/photo-1586281380117-5a60ae2050cc?q=80&w=2670&auto=format&fit=crop",
                name: "invoice_image_3.jpg",
              },
            ].map((img, idx) => (
              <Col md={3} key={idx}>
                <div
                  className="bg-white rounded-3 overflow-hidden border border-light shadow-sm position-relative group-hover"
                  style={{ height: "200px" }}
                >
                  <img
                    src={img.url}
                    alt="invoice"
                    className="w-100 h-100 object-fit-cover"
                  />
                  <div className="position-absolute bottom-0 right-0 p-2">
                    <div
                      className="bg-white rounded-circle p-2 shadow-sm d-flex align-items-center justify-content-center border"
                      style={{ width: "32px", height: "32px", cursor: "pointer" }}
                      onClick={() =>
                        DownloadService.downloadFile(img.url, img.name)
                      }
                    >
                      <i className="fas fa-download fs-12 text-muted"></i>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </CommonModal>
  );
};

export default TransactionInformationModal;
